export enum DependencyFilter {
  All = 'all',
  Missing = 'missing',
  Available = 'available',
}

export enum DependencySortField {
  Status = 'status',
  Name = 'name',
  Path = 'path',
  Occurrences = 'occurrences',
}
